import Vue from 'vue';
import Transform from './Base';
import types from '@/utils/types';
import config from '@/config.json';

const formatStatuses = str => {
  const res = str.replace(/_/g, ' ');
  return res.charAt(0).toUpperCase() + res.slice(1);
}

export default class ProjectsTransform extends Transform {
  /**
   * Method used to transform fetched jobs.
   *
   * @param job The fetched job.
   *
   * @returns {Object} The transformed job.
   */
  static fetchStatuses(arr) {
    let res;
    try {
      res = arr.map(el => ({
        ...el,
        date: Vue.moment(el?.updated_at).format("DD-MM-YY HH:mm"),
        code_label: formatStatuses(el.code),
        status_label: formatStatuses(el.status),
      }));
    } catch {
      res = [];
    }
    return res;
  }

  static fetch(job) {
    let res;
    try {
      res = Object.assign({}, types.defaultProject(), {
        comments: job.comments ?? '',
        field: {
          length: job?.options?.tracking?.field?.length || 105,
          width: job?.options?.tracking?.field?.width || 68,
        },
        fps: job?.metadata?.fps || 25,
        id: job._id,
        job_name: job.job_name || '',
        name: `${job?.team_a?.team_name ?? ''} - ${job?.team_b?.team_name ?? ''}`,
        created_at: job.created_at,
        updated_at: job.updated_at,
        status: job.status,
        progress: job.status > 0 ? job.status / config.totalPhases : job.status,
        tracks_count: job.tracks_count,
        match: Object.assign({}, types.defaultMatch(), {
          date: job.game_date || '',
          team_a: Object.assign({}, types.defaultTeam(), {
            id: job?.team_a?._id ?? '',
            name: job?.team_a?.team_name ?? '',
            city: job?.team_a?.city ?? '',
            country: job?.team_a?.country ?? '',
            player_kit: job.team_a_outfit_id,
            goalkeeper_kit: job.team_a_gk_outfit_id,
            predefinedPlayers: job?.team_a_players || [],
            scheme: job?.team_a_scheme || '',
            team_id: job?.team_a_outfit?.team_id || null,
          }),
          team_b: Object.assign({}, types.defaultTeam(), {
            id: job?.team_b?._id || '',
            name: job?.team_b?.team_name || '',
            city: job?.team_b?.city || '',
            country: job?.team_b?.country || '',
            player_kit: job.team_b_outfit_id,
            goalkeeper_kit: job.team_b_gk_outfit_id,
            predefinedPlayers: job?.team_b_players || [],
            scheme: job?.team_b_scheme || '',
            team_id: job?.team_b_outfit?.team_id || null,
          }),
          referee_kit: job.referee_outfit_id,
          venue: Object.assign({}, types.defaultVenue(), {
            id: job.venue._id,
            field_length: job.venue.field_length,
            field_width: job.venue.field_width,
            name: job.venue.venue_name,
          }),
          video_tv: job.tv_file,
        }),
        models: {
          field: job?.field_model_type?.toString() || '',
          tracking: job.tracking_model_type ?? '',
          backend: job.use_scaling_group ?? ''
        },
        video: [
          Object.assign({}, types.defaultVideo(), {
            id: !!job.file ? job.file._id : job.file_id,
            name: !!job.file ? job.file.video_name : '',
            size: !!job.file ? job.file.video_size : -1,
            url: !!job.file ? job.file.video_url : job.video_url,
            fps: (!!job.file && !!job.file.metadata && !!job.file.metadata.fps) ? job.file.metadata.fps : 25,
            total_frames: (!!job.file && !!job.file.metadata) ? job.file.metadata.total_frames : 0,
            duration_sec: (!!job.file && !!job.file.metadata && !!job.file.metadata.fps && job.file.metadata.fps !== 0)
              ? job.file.metadata.total_frames / job.file.metadata.fps
              : (
                (!!job.metadata && !!job.metadata.fps && job.metadata.fps !== 0)
                  ? job.metadata.total_frames / job.metadata.fps
                  : 0
              ),
            originalHeight: !!job.file && !!job.file.metadata && job.file.metadata.frame_height,
            originalWidth: !!job.file && !!job.file.metadata && job.file.metadata.frame_width,
            tv_file_id: job.tv_file_id || null,
            videoHash: job.file?.video_hash || null,
          })
        ],
        options: Object.assign({}, types.defaultOptions()),
        isRunning: job.status > 0 && job.status < config.totalPhases,
        videoStatuses: {
          detect: !!job?.statuses?.detections_video_ready,
          field: !!job?.statuses?.field_video_ready,
          track: !!job?.statuses?.tracks_video_ready,
        },
      });
    } catch {
      res = null;
    }
    return res;
  }
}
